import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';
import css from './CategoriesNavigation.module.scss';
import LinkButton from '../Models/LinkButton/LinkButton';

const CategoriesNavigation = ({
    categories,
}) => categories && categories.length > 0 ? (
    <div className={css.block}>
        <div className={css['categories-container']}>
            <ul className={css['categories-list']}>
                {categories.map((category, i) => (
                    <li key={i}  className={css['categories-list-item']}>
                        <Button href={category.url} target={category.target} isActive={category.isActive} secondary  className={css['category-button']}>{category.text}</Button>
                    </li>
                ))}
            </ul>
        </div>
    </div>
) : null;

CategoriesNavigation.propTypes = {
    categories: PropTypes.arrayOf(
        PropTypes.shape(LinkButton.propTypes)
    )
};

export default CategoriesNavigation;



// WEBPACK FOOTER //
// ./src/components/CategoriesNavigation/CategoriesNavigation.jsx